import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import * as React from "react";
import { SFC } from "react";
import { Divider } from "semantic-ui-react";
import Notice from "../../../domain/notice/Notice";

interface Props {
  notice: Notice;
}

const NoticeDetail: SFC<Props> = (props: Props) => {
  const {title, content} = props.notice;
  return (
    <>
      <ExpansionPanel>
        <ExpansionPanelSummary
          expandIcon={ <ExpandMore/> }
        >
          { title.value }
        </ExpansionPanelSummary>
        <Divider/>
        <ExpansionPanelDetails>
          <div dangerouslySetInnerHTML={ {__html: content.value} }/>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </>
  );
};

export default NoticeDetail;
